// AddExcursionModal.js
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { collection, addDoc, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const SHIFT_OPTIONS = [
  { time: "6:00 AM", name: "Morning walk" },
  { time: "6:45 AM", name: "Yoga" },
  { time: "9:15 AM", name: "Shopping" },
  { time: "10:10 AM", name: "Gym (Sunday Outing)" },
  { time: "12:00 PM", name: "Beach meeting" },
  { time: "03:10 PM", name: "Massage" },
];

function AddExcursionModal({ open, onClose }) {
  const [selectedShift, setSelectedShift] = useState("");

  const handleShiftChange = (event) => {
    setSelectedShift(event.target.value);
  };

  const handleAdd = async () => {
    if (!selectedShift) return;
    // Récupérer la date d'aujourd'hui au format YYYY-MM-DD
    const today = new Date();
    const year = today.getFullYear();
    const month = ("0" + (today.getMonth() + 1)).slice(-2);
    const day = ("0" + today.getDate()).slice(-2);
    const todayStr = `${year}-${month}-${day}`;

    const shift = SHIFT_OPTIONS.find((option) => option.name === selectedShift);

    // Récupérer la liste des clients In House
    const inHouseQuery = query(
      collection(db, "clients"),
      where("clientStatus", "==", "In House")
    );
    const inHouseSnapshot = await getDocs(inHouseQuery);
    const inHouseClients = inHouseSnapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        firstName: data.firstName || "",
        lastName: data.lastName || "",
        profilePicture: data.profilePicture || "",
        // Vous pouvez ajouter d'autres champs si nécessaire
      };
    });

    const newExcursion = {
      date: todayStr,
      shift: shift,
      attendances: inHouseClients, // La liste figée des clients In House
    };
    try {
      await addDoc(collection(db, "clientExcursions"), newExcursion);
      onClose();
    } catch (error) {
      console.error("Error adding excursion:", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add an Excursion</DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <InputLabel id="excursion-shift-label">Select Shift</InputLabel>
          <Select
            labelId="excursion-shift-label"
            value={selectedShift}
            label="Select Shift"
            onChange={handleShiftChange}
          >
            {SHIFT_OPTIONS.map((option, index) => (
              <MenuItem key={index} value={option.name}>
                {`${option.time} - ${option.name}`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleAdd} variant="contained" color="primary">
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddExcursionModal;
